//Action Type for Shortcut Apps

// Get Shortcut Apps List
export const GET_SHORTCUT_APPS_LIST = "GET_SHORTCUT_APPS_LIST";
export const GET_SHORTCUT_APPS_LIST_SUCCESS = "GET_SHORTCUT_APPS_LIST_SUCCESS";
export const GET_SHORTCUT_APPS_LIST_ERROR = "GET_SHORTCUT_APPS_LIST_ERROR";

// Get Shortcut app data details
export const GET_SHORTCUT_APP_DATA = "GET_SHORTCUT_APP_DATA";
export const GET_SHORTCUT_APP_DATA_SUCCESS = "GET_SHORTCUT_APP_DATA_SUCCESS";
export const GET_SHORTCUT_APP_DATA_ERROR = "GET_SHORTCUT_APP_DATA_ERROR";

// Create Shortcut app data
export const CREATE_SHORTCUT_APP_DATA = "CREATE_SHORTCUT_APP_DATA";
export const CREATE_SHORTCUT_APP_DATA_SUCCESS =
  "CREATE_SHORTCUT_APP_DATA_SUCCESS";
export const CREATE_SHORTCUT_APP_DATA_ERROR = "CREATE_SHORTCUT_APP_DATA_ERROR";

// Update Shortcut app data
export const UPDATE_SHORTCUT_APP_DATA = "UPDATE_SHORTCUT_APP_DATA";
export const UPDATE_SHORTCUT_APP_DATA_SUCCESS =
  "UPDATE_SHORTCUT_APP_DATA_SUCCESS";
export const UPDATE_SHORTCUT_APP_DATA_ERROR = "UPDATE_SHORTCUT_APP_DATA_ERROR";

// Delete Shortcut app data
export const DELETE_SHORTCUT_APP_DATA = "DELETE_SHORTCUT_APP_DATA";
export const DELETE_SHORTCUT_APP_DATA_SUCCESS =
  "DELETE_SHORTCUT_APP_DATA_SUCCESS";
export const DELETE_SHORTCUT_APP_DATA_ERROR = "DELETE_SHORTCUT_APP_DATA_ERROR";
